import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=d5b825f4&scoped=true&"
import script from "./BaseLink.vue?vue&type=script&lang=ts&"
export * from "./BaseLink.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=d5b825f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b825f4",
  null
  
)

export default component.exports